import { defineDirective, FieldViewModel, IOmniaShell, shell, SoilAnalysisType, soilColors, SoilUnit } from "../../omnia"
import { IAnalysisValueColumn, ISoilService, LayerTypeId } from "../../types"
import { restoreColumns, saveColumns } from "../columns"
import { SoilMapContext } from "../map/context"
import { editSoilAnalysis, getAnalysisIndex, getTableContext, selectSoilAnalysis } from "../soil/shared"
import { SoilAnalysisVM } from "../soil/soil-vm"
import { IDashboardContext } from "../types"

export class SsmAnalysisTableCtrl {

    static create(): ng.IDirective {
        return defineDirective(SsmAnalysisTableCtrl, "app/soil/dashboard/ssm/ssm.html", {
            context: "="
        })
    }

    public readonly readOnly = this.shell.isReadOnly(p => p.soil)

    context: IDashboardContext

    map: SoilMapContext
    selectedField: FieldViewModel

    soilAnalysis: SoilAnalysisVM[]

    showSoilAnalysisHistory: boolean
    private columnsDefinitions: IAnalysisValueColumn[]

    static $inject = ["$scope", "OmniaSoilService", "OmniaShell"]

    constructor(
        $scope: ng.IScope,
        private svc: ISoilService,
        private shell: IOmniaShell,
        private readonly table = getTableContext(() => svc.units.soil)) {

        $scope.$watch("vm.context", () => this.setup())

    }


    private setup() {

        this.map = null
        this.selectedField = null
        this.soilAnalysis = null

        if (!this.context) return

        this.columnsDefinitions = restoreColumns(this.svc.settings)

        this.map = this.context.map

        this.selectedField = this.context.selectedField
        const selectedZone = this.context.selectedZone
        const soilAnalysisLayers = (this.context.layers || []).filter(l => l.TypeId == LayerTypeId.SoilAnalysis)


        if (this.selectedField) {

            let currentViewKey = this.map.group ? this.map.group.key : null

            let selectedZoneId = selectedZone ? selectedZone.zone.DataLayerZoneId : null
            let hsa = !!this.context.selectedHsaId

            let soilAnalysis = SoilAnalysisVM.create(
                this.svc,
                SoilAnalysisType.SSM,
                soilAnalysisLayers,
                this.selectedField,
                selectedZoneId,
                (!hsa) && (currentViewKey == "S")
            )

            if (soilAnalysis) {

                this.soilAnalysis = soilAnalysis

            }

        }

    }

    select() {
        if (!this.showTerraMap) {
            this.map.selectView("S")
        }
    }

    selectSoilAnalysis(a: SoilAnalysisVM, element?: string) {
        selectSoilAnalysis(this.context, a, this.selectedField, element)
    }

    editColumns() {

        this.shell.showComponentAsDialog("omnia-soil-dashboard-columns-popup",
            {
                columns: this.columnsDefinitions,
                max: 5
            }, {
            backdrop: "static"
        }).then(r => saveColumns(this.svc.settings, this.columnsDefinitions))

    }

    allocAnalysis() {

        this.shell.showComponentAsDialog("omnia-soil-soilanalysis-alloc-popup", this.selectedField, {
            backdrop: "static",
            size: "xlarge"
        }).then(r => {
            this.context.refresh()
        })

    }

    unAllocAnalysis(vm: SoilAnalysisVM) {

        var msg = "You are about to unallocate this soil analysis from the field " + this.selectedField.description + ". Are you sure ?"

        shell.showDeleteCancel(this.shell, msg, "Unallocate").then(r => {
            if (r) {
                this.svc.unallocSoilAnalysis(vm.analysis.SoilAnalysisId, this.selectedField.fieldId)
                    .then(r => this.context.refresh())
            }
        })

    }

    editSoilAnalysis(vm: SoilAnalysisVM) {
        return editSoilAnalysis(this.context, SoilAnalysisType.SSM, vm, this.selectedField)
    }

    createSoilAnalysis() {
        this.editSoilAnalysis(null)
    }

    hasHistoricalSoilAnalysis() {
        return this.soilAnalysis?.some(s => !s.current)
    }

    get unitsAsIndex() {
        return (this.svc.units.soil == SoilUnit.Index)
    }

    getGaugeStyle(c: IAnalysisValueColumn, value: number): any {
        return soilColors.getGaugeStyle(value, c.key || c.name)
    }

    getAnalysisIndex(c: IAnalysisValueColumn, vm: SoilAnalysisVM) {
        return getAnalysisIndex(c, vm)
    }

    getTableColumnUnits(c: IAnalysisValueColumn) {
        return this.table.getTableColumnUnits(c)
    }

    getTableCellValue(c: IAnalysisValueColumn, a: SoilAnalysisVM) {
        return this.table.getTableCellValue(c, a)
    }

    get showTerraMap() {
        return this.map?.showTerraMap
    }

    set showTerraMap(value) {
        this.map.showTerraMap = value
    }

}
